import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { AuthService, authInterceptor, PUBLIC_ROUTES, POST_LOGOUT_ROUTE } from '@nomoh-monorepo/data-access-auth';
import { provideI18n } from '@nomoh-monorepo/data-access-shared-i18n';
import { httpConfigInterceptor } from '@nomoh-monorepo/shared-interceptors';
import {
  CORE_PROVIDERS,
  createAuthProviders,
} from '@nomoh-monorepo/shared-util-angular-config';
import { LuxonNomoh } from '@nomoh-monorepo/shared-util-luxon-nomoh';
import { appRoutes } from './app.routes';

// Chame a configuração do Luxon antes de inicializar a aplicação
LuxonNomoh.configureLuxon();
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      })
    ),
    ...CORE_PROVIDERS,

    // Auth + HTTP Config (withCredentials + Accept-Language)
    ...createAuthProviders(AuthService, authInterceptor, httpConfigInterceptor),

    { provide: POST_LOGOUT_ROUTE, useValue: '/' },

    provideI18n('nomoh-cliente'),
    {
      provide: PUBLIC_ROUTES,
      useValue: [
        '/',
        '/login',
        '/cadastrar',
        '/recuperar-senha',
        '/bardo',
        '/privacidade',
      ],
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
